export const state = () => ({
  showConfirmPasswordModal: false,
  showSubmitHelperModal: false,
  showSubscriptionExpiredModal: false,
  showUnlockWillModal: false,
  showNotifyCharityConsentModal: false,
  showFlaggedWillAttentionModal: false,
});

export const getters = {
  showConfirmPasswordModal: (state) => state.showConfirmPasswordModal,
  showSubmitHelperModal: (state) => state.showSubmitHelperModal,
  showSubscriptionExpiredModal: (state) => state.showSubscriptionExpiredModal,
  showUnlockWillModal: (state) => state.showUnlockWillModal,
  showNotifyCharityConsentModal: (state) => state.showNotifyCharityConsentModal,
  showFlaggedWillAttentionModal: (state) => state.showFlaggedWillAttentionModal,
};

export const mutations = {
  showConfirmPasswordModal(state, value) {
    state.showConfirmPasswordModal = value;
  },
  showSubmitHelperModal(state, value) {
    state.showSubmitHelperModal = value;
  },
  showSubscriptionExpiredModal(state, value) {
    state.showSubscriptionExpiredModal = value;
  },
  showUnlockWillModal(state, value) {
    state.showUnlockWillModal = value;
  },
  showNotifyCharityConsentModal(state, value) {
    state.showNotifyCharityConsentModal = value;
  },
  showFlaggedWillAttentionModal(state, value) {
    state.showFlaggedWillAttentionModal = value;
  },
};

export const actions = {
  setShowConfirmPasswordModal({ commit }, value) {
    commit('showConfirmPasswordModal', value);
  },
  setShowSubmitHelperModal({ commit }, value) {
    commit('showSubmitHelperModal', value);
  },
  setShowSubscriptionExpiredModal({ commit }, value) {
    commit('showSubscriptionExpiredModal', value);
  },
  setShowUnlockWillModal({ commit }, value) {
    commit('showUnlockWillModal', value);
  },
  setShowNotifyCharityConsentModal({ commit }, value) {
    commit('showNotifyCharityConsentModal', value);
  },
  setShowFlaggedWillAttentionModal({ commit }, value) {
    commit('showFlaggedWillAttentionModal', value);
  },
  resetUI({ commit }) {
    commit('showConfirmPasswordModal', false);
    commit('showSubscriptionExpiredModal', false);
    commit('showUnlockWillModal', false);
    commit('showNotifyCharityConsentModal', false);
    commit('showFlaggedWillAttentionModal', false);
  },
};
